import styled from 'styled-components';
import { media } from 'designsystem/index';

const BackgroundImage = styled.img`
  position: relative;
  display: block;
  height: 490px;
  width: 100%;
  object-fit: cover;
  
  ${media.desktop`
    height: 600px;
  `}
`;

export default BackgroundImage;



// WEBPACK FOOTER //
// ./src/kentico-blocks/ImageSlider/ImageSlide/BackgroundImage.jsx